import { atom } from 'recoil';
import { User } from 'Models';
import LocalForageEffect from '../LocalForageEffect';

export default atom<User | undefined>({
  key: 'user',
  default: undefined,
  effects_UNSTABLE: [LocalForageEffect<User | undefined>('user')],
});
